import { useQuery } from '@apollo/client';
import {
  ISampleContentData,
  SAMPLE_CONTENT,
} from '@quesmed/types-rn/resolvers/query';

import { AppProductType } from 'types';

export const useSampleData = (productType: AppProductType, skip = false) => {
  const { data, loading } = useQuery<ISampleContentData>(SAMPLE_CONTENT, {
    context: {
      headers: {
        SampleProduct: `${productType}`,
      },
    },
    skip,
  });

  const { sampleContent } = data || {};

  const { marksheets, osceMarksheets } = sampleContent || {};

  return { loading, marksheets, osceMarksheets };
};
